export default {
    "name": "RemoveChartFromReportMutation",
    "kind": "HoudiniMutation",
    "hash": "d0765d1744ead88c26c28276759b3149008c553b556e49c0725fa58569f85a5d",

    "raw": `mutation RemoveChartFromReportMutation($reportId: Int!, $chartId: Int!) {
  removeChartFromDashboardReport(reportId: $reportId, chartId: $chartId) {
    chartId: id
    showChart: display
    inReport
    rank
    supertype
    title
    chartType: type
    id
  }
}
`,

    "rootType": "Mutation",
    "stripVariables": [],

    "selection": {
        "fields": {
            "removeChartFromDashboardReport": {
                "type": "DashboardChart",
                "keyRaw": "removeChartFromDashboardReport(chartId: $chartId, reportId: $reportId)",

                "selection": {
                    "fields": {
                        "chartId": {
                            "type": "Int",
                            "keyRaw": "chartId",
                            "visible": true
                        },

                        "showChart": {
                            "type": "Boolean",
                            "keyRaw": "showChart",
                            "visible": true
                        },

                        "inReport": {
                            "type": "Boolean",
                            "keyRaw": "inReport",
                            "nullable": true,
                            "visible": true
                        },

                        "rank": {
                            "type": "Int",
                            "keyRaw": "rank",
                            "nullable": true,
                            "visible": true
                        },

                        "supertype": {
                            "type": "DashboardChartSupertype",
                            "keyRaw": "supertype",
                            "visible": true
                        },

                        "title": {
                            "type": "String",
                            "keyRaw": "title",
                            "visible": true
                        },

                        "chartType": {
                            "type": "String",
                            "keyRaw": "chartType",
                            "nullable": true,
                            "visible": true
                        },

                        "id": {
                            "type": "Int",
                            "keyRaw": "id",
                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {
            "isManualLoad": true
        }
    },

    "input": {
        "fields": {
            "reportId": "Int",
            "chartId": "Int"
        },

        "types": {},
        "defaults": {},
        "runtimeScalars": {}
    }
};

"HoudiniHash=a878215cc56cfba39e20f63abec4fa521c7f37d1ba1014857af599e37021f238";